import React,{ Component } from "react";
import { connect } from "react-redux";
import { getServers, deleteServer, updateServer, destroyAgentKasms,setAgentPageInfo } from "../../actions/actionServer";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader, Progress } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import moment from "moment";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select";
import "react-select/dist/react-select.css";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agents",path:"/agents",isActive: true}
];

class Agents extends Component{
    constructor(props) {
        super(props);  
        
        this.state = {
            modal: false,
            pages: 1,
            serverId: null,
            server_type: 'host',
            agentsModal: false,
            selectedAgents: [],
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.destroyKasmsConfirm = this.destroyKasmsConfirm.bind(this);
        this.deleteServerAction = this.deleteServerAction.bind(this);
        this.destroyKasmsAction = this.destroyKasmsAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.cancelDestroy =  this.cancelDestroy.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleDestroyKasmSuccess = this.handleDestroyKasmSuccess.bind(this);
        this.handleDestroyKasmError = this.handleDestroyKasmError.bind(this);
        this.assignServer = this.assignServer.bind(this);
        this.cancelServersModal = this.cancelServersModal.bind(this);
        this.handleChangeServers = this.handleChangeServers.bind(this);

    }

    componentDidMount(){
        this.props.getServers();
    }

    async assignServer() {
        await Promise.all(this.state.selectedAgents.map(async server => {
            const serverToUpdate = this.props.servers.find(all => all.server_id === server.value)
            serverToUpdate.server_pool_id = this.props.pool
            await this.props.updateServer(serverToUpdate)
        }))

        this.props.getServers()
        this.setState({ selectedAgents: [], agentsModal: false });
    }

    cancelServersModal() {
        this.setState({ agentsModal: !this.state.agentsModal });
    }


    handleChangeServers(selectedAgents) {
        this.setState({ selectedAgents });
    }


    deleteConfirm(serverId){
        this.setState({modal: !this.state.modal, serverId: serverId});
    }

    destroyKasmsConfirm(serverId){
        this.setState({destroyModal: !this.state.destroyModal, serverId: serverId});
    }

    cancelDestroy(){
        this.setState({destroyModal: !this.state.destroyModal});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteServerAction(){
        this.props.deleteServer(this.state.serverId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    destroyKasmsAction(){
        this.props.destroyAgentKasms(this.state.serverId).
            then(() => this.handleDestroyKasmSuccess()).
            catch(() => this.handleDestroyKasmError());
    }

    handleDeleteSuccess(){
        const {deleteServerErrorMessage} = this.props;
        if(deleteServerErrorMessage) {
            NotificationManager.error(deleteServerErrorMessage,"Delete Agent", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.success("Successfully Deleted Agent","Delete Agent", 3000);
            this.setState({modal: false});
            this.props.getServers();
        }
    }

    handleDeleteError(){
        const {deleteServerError} = this.props;
        if(deleteServerError){
            NotificationManager.error(deleteServerError,"Delete Agent", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.error("Failed to Delete Agent","Delete Agent", 3000);
            this.setState({modal: false});
        }
    }

    handleDestroyKasmSuccess(){
        const {destroyAgentKasmsErrorMessage} = this.props;
        if(destroyAgentKasmsErrorMessage) {
            NotificationManager.error(destroyAgentKasmsErrorMessage,"Delete Sessions", 3000);
            this.setState({destroyModal: false});
        }
        else{
            NotificationManager.success("Successfully marked Sessions for deletion","Delete Sessions", 3000);
            this.setState({destroyModal: false});
            this.props.getServers();
        }
    }

    handleDestroyKasmError(){
        const {destroyAgentKasmsError} = this.props;
        if(destroyAgentKasmsError){
            NotificationManager.error(destroyAgentKasmsError,"Delete Sessions", 3000);
            this.setState({destroyModal: false});
        }
        else{
            NotificationManager.error("Failed to mark Sessions for deletion","Delete Sessions", 3000);
            this.setState({destroyModal: false});
        }
    }

    render(){
        if (this.props.getServersLoading){
            return (<div> <LoadingSpinner /></div>);
        }


        const { servers } = this.props;
        let filtered_servers = servers.filter(x => x.server_type === this.state.server_type)

        let unattached_servers = [
            ...filtered_servers
        ]

        if (this.props.pool) {
            unattached_servers = unattached_servers.filter(config => config.server_pool_id !== this.props.pool)
            filtered_servers = filtered_servers.filter(config => config.server_pool_id === this.props.pool)
        }

        let optionsServers = [];
        unattached_servers.map(opt => {
            optionsServers.push({ label: opt.hostname, value: opt.server_id });
        });



        const UsageProgress = (field) => (data) => {
          const value = data.value;
          const percentage = _.get(data.original, field);

          return percentage < value ? (
            <Progress multi>
              <Progress
                bar
                color={percentage < 80 ? "success" : "danger"}
                value={percentage}
              />
              <Progress bar color="info" value={value - percentage} />
            </Progress>
          ) : (
            <Progress multi>
              <Progress bar color="info" value={value} />
              <Progress
                bar
                color={percentage < 80 ? "success" : "danger"}
                value={percentage - value}
              />
            </Progress>
          );
        };

        const columns = [
          {
            type: "text",
            name: "Hostname",
            accessor: "hostname",
            filterable: true,
            sortable: true,
          },
          {
            type: "date",
            accessor: "created",
            name: "Created",
            filterable: true,
            sortable: true,
            cell: (data) => <div>{moment(data.value).isValid() ? moment.utc(data.value).local().format("L h:mm A") : "-"}</div>
          },
          {
            type: "text",
            name: "Agent Id",
            accessor: "server_id",
            filterable: true,
            sortable: true,
          },
          {
            type: "flag",
            name: "Enabled",
            accessor: "enabled",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Last Reported",
            accessor: "last_reported_elapsed",
            filterable: false,
            sortable: true,
          },
          {
            type: "text",
            name: "Status",
            accessor: "operational_status",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Manager",
            accessor: "manager.manager_hostname",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Zone",
            accessor: "zone.zone_name",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Sessions",
            accessor: "kasms.length",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Autoscale Config",
            accessor: "autoscale_config.autoscale_config_name",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "Provider",
            accessor: "provider",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            name: "GPUs",
            accessor: "gpus",
            filterable: true,
            sortable: true,
          },
          {
            type: "text",
            accessor: "core_calculations.percentage",
            name: "CPU Usage",
            filterable: true,
            sortable: true,
            cell: UsageProgress("cpu_percent")
          },
          {
            type: "text",
            accessor: "memory_calculations.percentage",
            name: "Memory Usage",
            filterable: true,
            sortable: true,
            cell: UsageProgress("memory_stats.percent")
          },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete-agents", icon: "fa-trash", description: "Delete Agents" },
            { id: "delete-sessions", icon: "fa-trash", description: "Delete Sessions" },
        ];

        const haspool = (this.props.pool) ? '?pool=' + this.props.pool : ''

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewagent/${item.server_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateagent/${item.server_id}${haspool}`);
                break;

                case "delete-agents":
                    this.deleteConfirm(item.server_id);
                break;

                case "delete-sessions":
                    this.destroyKasmsConfirm(item.server_id);
                break;
            }
        }


        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: this.props.pool ? 8 : 10, order: 3, offset: this.props.pool ? 2 : 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-cubes"></i> <strong>Docker Agents</strong></div>
                                <Row>
                                        {this.props.pool && (
                                            <div className="pull-right add-btn tw-mr-3">
                                                <button onClick={() => this.setState({ agentsModal: true })} className="pull-right adduser-btn !tw-bg-[#181f471a] tw-text-color dark:!tw-bg-[#363d5d] dark:tw-text-white" size="sm" color="dark">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    Assign
                                                </button>
                                            </div>

                                        )}
                                </Row>

                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="agents"
                                    data={filtered_servers}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.agentsModal} toggle={this.cancelServersModal} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelServersModal}>Assign Existing Agents(s) To This Pool
                    </ModalHeader>
                    <ModalBody>

                        <Select
                            name="servers"
                            multi={true}
                            options={optionsServers}
                            value={this.state.selectedAgents}
                            onChange={this.handleChangeServers}
                        />


                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelServersModal}
                            className="cancel-button"
                            size="sm" color="basic"> Close</Button>
                        <Button onClick={this.assignServer}
                            className="submit-button"
                            size="sm" color="success"> Assign</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Agent?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} 
                        className="cancel-button"
                        size="sm" color="basic"> Close</Button>
                        <Button onClick={this.deleteServerAction} 
                        className="delete-button"
                        size="sm" color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.destroyModal} toggle={this.cancelDestroy} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDestroy}>Are you sure you want to delete this sessions?
                    </ModalHeader>
                    <ModalBody className="confirm-modal-body">
                        Sessions that reside on this Agent will be marked for deletion. They will be destroyed in a few moments.
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelDestroy} className="cancel-button"  size="sm" color="basic"> Close</Button>
                        <Button className="delete-button" onClick={this.destroyKasmsAction} size="sm" color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Agents.propTypes = {
    getServers: Proptypes.func.isRequired,
    deleteServer: Proptypes.func.isRequired,
    destroyAgentKasms: Proptypes.func.isRequired,
    deleteServerError: Proptypes.func,
    destroyAgentKasmsError: Proptypes.func,
    servers: Proptypes.array,
    getServersLoading: Proptypes.bool,
    deleteServerErrorMessage: Proptypes.func,
    destroyAgentKasmsErrorMessage: Proptypes.func,
    className: Proptypes.func
};

let AgentsWithRouter = withRouter(Agents);

export default connect(state => 
    ({
        servers: state.servers.servers || [],
        deleteServerErrorMessage: state.servers.deleteServerErrorMessage || null,
        destroyAgentKasmsErrorMessage: state.servers.destroyAgentKasmsErrorMessage || null,
        getServersLoading: state.servers.getServersLoading || false,
        deleteServerError: state.servers.deleteServerError || null,
        destroyAgentKasmsError: state.servers.destroyAgentKasmsError || null,
        pages : {pageSize : state.servers.pageSize, pageNo : state.servers.pageNo},


    }),
dispatch => 
    ({  
        getServers: () => dispatch(getServers()),
        deleteServer: (data) => dispatch(deleteServer(data)),
        destroyAgentKasms: (data) => dispatch(destroyAgentKasms(data)),
        setPageInfo : (data)=> dispatch(setAgentPageInfo(data)),  
        updateServer: (data) => dispatch(updateServer(data)),
    }))(AgentsWithRouter);